module.exports = __webpack_public_path__ + "img/home_bg_taiwan.b1c001e2.jpg";